export default __webpack_public_path__ + "static/04_planning_guides-024a9ce18fea5eb365f3a46698b0a29f.png";